import { useEffect, useRef, useState } from "react";
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";

export default function SearchSelect({ value, onChange, options, placeholder = "All — type to search", testid }) {
  const [text, setText] = useState("");
  const [open, setOpen] = useState(false);
  const [hi, setHi] = useState(0);
  const box = useRef(null);
  const sel = options.find((o) => o[0] === value);
  const shown = options.filter((o) => o[1].toLowerCase().includes(text.toLowerCase())).slice(0, 60);

  useEffect(() => {
    const close = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const pick = (o) => { onChange(o ? o[0] : ""); setText(""); setOpen(false); };
  const onKey = (e) => {
    if (e.key === "ArrowDown") { e.preventDefault(); setOpen(true); setHi((h) => Math.min(h + 1, shown.length - 1)); }
    if (e.key === "ArrowUp") { e.preventDefault(); setHi((h) => Math.max(h - 1, 0)); }
    if (e.key === "Enter" && open && shown[hi]) { e.preventDefault(); pick(shown[hi]); }
    if (e.key === "Escape" || e.key === "Tab") setOpen(false);
  };

  return (
    <div className="relative" ref={box}>
      <Search className="w-3.5 h-3.5 text-slate-400 absolute left-2.5 top-1/2 -translate-y-1/2" />
      <Input value={open ? text : sel?.[1] || ""} placeholder={sel ? sel[1] : placeholder} className="pl-8 pr-7 h-9 text-sm" data-testid={testid} autoComplete="off"
        onFocus={() => { setOpen(true); setHi(0); }} onKeyDown={onKey} onChange={(e) => { setText(e.target.value); setOpen(true); setHi(0); }} />
      {sel && <button type="button" onClick={() => pick(null)} className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-red-600" data-testid={`${testid}-clear`}><X className="w-3.5 h-3.5" /></button>}
      {open && (
        <div className="absolute z-40 mt-1 w-full min-w-[220px] bg-white border border-slate-200 rounded-md shadow-lg max-h-64 overflow-auto" data-testid={`${testid}-options`}>
          {shown.map((o, i) => (
            <button type="button" key={o[0]} onMouseDown={(e) => { e.preventDefault(); pick(o); }} data-testid={`${testid}-option-${i}`}
              className={`w-full text-left px-3 py-1.5 text-sm truncate ${i === hi ? "bg-emerald-50" : "hover:bg-slate-50"} ${o[0] === value ? "font-medium text-emerald-800" : "text-slate-700"}`}>{o[1]}</button>
          ))}
          {!shown.length && <div className="px-3 py-2.5 text-xs text-slate-400">No matches</div>}
        </div>
      )}
    </div>
  );
}
